import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var ActionCard = function ActionCard(_ref) {
  var link = _ref.link,
    _onClick = _ref.onClick,
    title = _ref.title;
  if (!_onClick && !link) {
    return null;
  }
  return link ? /*#__PURE__*/React.createElement("a", {
    className: cn('link'),
    href: link,
    rel: "noopener noreferrer",
    target: "_blank",
    "data-t-id": "components-ActionCard"
  }, /*#__PURE__*/React.createElement("span", {
    className: cn('only')
  }, title)) : /*#__PURE__*/React.createElement("button", {
    className: cn('button'),
    onClick: function onClick() {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick(title);
    },
    type: "button"
  }, /*#__PURE__*/React.createElement("span", {
    className: cn('only')
  }, title));
};